<template>
  <div>
    <b-row>
      <b-col md="6" xl="6" lg="6" sm="6" xs="6">
        <h4 class="page-title">Email To {{$route.query.cus_name}}</h4>
      </b-col>
      <b-col md="6" xl="6" lg="6" sm="3" xs="6" class="text-right" style="float:right">
        <!-- For Template name -->
        <b-dropdown variant="link" toggle-class="text-decoration-none" size="sm" :text="name">
          <b-dropdown-item
            :class="{'filter_dropdown' : true}"
            :to="{name:'Email',query:{template_id:item.template_id,tns_mail:$route.query.tns_mail,tns_type:$route.query.tns_type,tns_date:$route.query.tns_date,
            tns_no:$route.query.tns_no, tns_currency:$route.query.tns_currency,cus_id:$route.query.cus_id,cus_name:$route.query.cus_name,id:$route.query.id}}"
            v-for="item in mail_list"
            :key="item.template_id"
            @click="name = item.template_name,changetemplate(item.template_id)"
          >{{ item.template_name }}</b-dropdown-item>
        </b-dropdown>
        <a @click="redirectPage()">
          <i class="mt-2 la la-remove la-lg text-decoration-none"></i>
        </a>
      </b-col>
    </b-row>
    <!-- </b-col> -->
    <!-- Alert message -->
    <b-row style="margin-top:6px;">
      <b-col xl="12" lg="12" md="12" xs="12" sm="12">
        <div class="container-fluid">
          <b-alert class="alert-transparent alert-danger" :show="error_show || this.errors.any()">
            <button type="button" @click="error_show=!error_show" class="close">
              <span aria-hidden="true">&times;</span>
            </button>
            <div v-for="item in errors.items" :key="item.id" v-if="item.scope=='email-form'">
              <p class="fw-semi-bold">{{ item.msg }}</p>
            </div>
         
          
            <div v-if="error_show_mail">
              <p class="fw-semi-bold">{{mail_error}}</p>
            </div>
          </b-alert>
        </div>
      </b-col>
    </b-row>
    <!-- Form -->
    <b-form method="post" @submit.prevent="onSubmit('email-form')" data-vv-scope="email-form">
      <b-row class="pt-2" style="max-width:1200px;">
        <!-- Mail from address -->
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-form-group
            horizontal
            :label-cols="2"
            :label-class=" 'required'"
            label="From"
            label-for="from_address"
          >
            <b-form-input
              id="from_address"
              type="text"
              size="sm"
              data-vv-name="from address"
              v-model.trim="field.from_address"
              v-validate="'required|email'"
              name="from_address"
              placeholder
            />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- Mail to address -->
      <b-row class="pt-2" style="max-width:1200px;">
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-form-group
            horizontal
            :label-cols="2"
            :label-class=" 'required'"
            label="Send To"
            label-for="to_mail"
          >
        
            <vue-tags-input
              v-model="field.to_mail.label"
              :tags="field.to_mail.name"
              name="to_mail"
              data-vv-name="to address"
              v-validate="field.to_mail.name.length!=0?'email':''"
              placeholder="Add mail"
              @tags-changed="newTags => field.to_mail.name = newTags"
              @before-adding-tag="checkTag"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- CC address -->
      <b-row class="pt-2" style="max-width:1200px;">
        <b-col xl="12" lg="12" md="12" sm="12" xs="12" v-if="show_bcc==2">
          <b-form-group horizontal :label-cols="2" label="Cc" label-for="cc_me">
            <vue-tags-input
              v-model="field.cc_me.label"
              :tags="field.cc_me.name"
              name="cc mail"
              data-vv-name="cc mail"
              v-validate="'email'"
              @tags-changed="newTags => field.cc_me.name = newTags"
              placeholder="Add Cc mail"
              @before-adding-tag="checkTag"
            />
          </b-form-group>
        </b-col>
        <!-- After bcc was clicked cc address -->
        <b-col xl="11" lg="11" md="11" sm="11" xs="11" v-if="show_bcc!=2">
          <b-form-group horizontal :label-cols="2" label="Cc" label-for="bcc_me">
            <vue-tags-input
              v-model="field.cc_me.label"
              :tags="field.cc_me.name"
              name="cc mail"
              data-vv-name="cc mail"
              v-validate="'email'"
              @tags-changed="newTags => field.cc_me.name = newTags"
              class="ml-3"
              placeholder="Add Cc mail"
              @before-adding-tag="checkTag"
            />
          </b-form-group>
        </b-col>
        <!-- Show bcc link -->
        <b-col xl="1" lg="1" md="1" sm="1" xs="1" class="mt-2">
          <span
            class="text-link cursor_pointer fw-semi-bold"
            @click="show_bcc=2"
            v-show="show_bcc!=2"
          >Bcc</span>
        </b-col>
      </b-row>
      <!-- Bcc mail -->
      <b-row class="pt-2" style="max-width:1200px;" v-if="show_bcc==2">
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-form-group horizontal :label-cols="2" label="Bcc" label-for="bcc_me">
            <vue-tags-input
              v-model="field.bcc_me.label"
              :tags="field.bcc_me.name"
              name="bcc mail"
              data-vv-name="bcc mail"
              v-validate="'email'"
              @tags-changed="newTags => field.bcc_me.name = newTags"
              placeholder="Add Bcc mail"
              @before-adding-tag="checkTag"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- Subject -->
      <b-row class="pt-2" style="max-width:1200px;">
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-form-group horizontal :label-cols="2" label="Subject" label-for="sub">
            <b-form-input
              id="sub"
              type="text"
              size="sm"
              v-model.trim="field.subject"
              name="subject"
              placeholder
            />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- Content box for mail -->
      <b-row class="pt-2" style="max-width:1200px;">
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-form-group horizontal :label-cols="2" label-for="sub">
            <trumbowyg
              v-model="field.body"
              data-vv-name="subject"
              v-validate="'required'"
              name="content"
            ></trumbowyg>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- Attach field -->
      <b-row class="pt-4" style="max-width:500px;">
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-form-group horizontal :label-cols="5" label-for="sub">
            <b-input-group>
              <b-input-group-prepend class="vselect-custom-add">
                <span class="input-group-text">
                  <i class="fa fa-file-pdf-o"></i>
                </span>
              </b-input-group-prepend>

              <b-form-input
                id="attach"
                type="text"
                size="sm"
                class="attach"
                v-model.trim="field.attach"
                name="attach"
                placeholder
                style="width:200px"
              />
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- Footer -->
      <div class="footer" style="box-shadow:0 -4px 5px -3px #ccc;">
        <div class="form-action" style="background:none !important;margin:0px;">
          <b-button
            type="submit"
            size="sm"
            variant="primary"
            class="btn-rounded mr-3"
            :disabled="submitted"
          >
            <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>Send
          </b-button>
        </div>
      </div>
    </b-form>
  </div>
</template>
<script>
import vSelect from "vue-select"; // vue seatch select component
import store from "@/store/index"; // vuex store fucntion
import trumbowyg from "vue-trumbowyg"; //For mail content
import { mapState, mapGetters } from "vuex"; //map state
import VueTagsInput from "@johmun/vue-tags-input"; //Multiple mail
import $ from "jquery"; // for using jquery function

//Before Route enter function
function getPageMail(routeTo, next) {
  var datas = {};
  store.state.general.oldRoute = routeTo.params.routepath;
  if (
    routeTo.query.tns_type != "Customer Statement" &&
    routeTo.query.tns_type != "Vendor Statement"
  ) {
    datas = JSON.stringify({
      tns_type: routeTo.query.tns_type,
      tns_id: routeTo.query.id,
      template_id: routeTo.query.template_id ? routeTo.query.template_id : "",
      date_format: routeTo.query.date_format
    });
  } else {
    datas = JSON.stringify({
      tns_type: routeTo.query.tns_type,
      tns_id: routeTo.query.id,
      template_id: routeTo.query.template_id ? routeTo.query.template_id : "",
      from_date: routeTo.query.from_date,
      to_date: routeTo.query.to_date,
      is_export: routeTo.query.is_export,
      date_format: routeTo.query.date_format
    });
  }
  store.dispatch("invoice/fetchMailLists", datas).then(() => {
    next();
  });
}

export default {
  name: "Email",
  components: {
    VueTagsInput,
    vSelect,
    trumbowyg
  },
  //Return function
  data() {
    return {
      error_show_mail: false,
      mail_error: "",
      name: "",
      show_bcc: "",
      tags: [],
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      error_show: false,
      submitted: false,
      field: this.createFreshEventObject()
    };
  },
  //methods
  methods: {
    redirectPage(){
      if(this.$route.query.tns_type=='Customer Statement'){
        this.$router.push({name:'CustomerView',params:{id:this.$route.query.cus_id},query:{tab_index:2}})
      }else{
        this.$router.go(-1)
      }
    },

    checkTag(obj) {
      if (obj.tag.text.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/)) {
        obj.addTag();
      } else {
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: "Enter valid email address",
          type: "danger",
          showCloseButton: true
        });
      }
    },
    //During template name change
    changetemplate(ev) {
      var data = {};
      if (
        this.$route.query.tns_type != "Customer Statement" &&
        this.$route.query.tns_type != "Vendor Statement"
      ) {
        data = JSON.stringify({
          tns_type: this.$route.query.tns_type,
          tns_id: this.$route.query.id,
          template_id: ev,
          from_date: this.$route.query.from_date,
          to_date: this.$route.query.to_date,
          is_export: this.$route.query.is_export
        });
      } else {
        data = JSON.stringify({
          tns_type: this.$route.query.tns_type,
          tns_id: this.$route.query.id,
          template_id: ev
        });
      }
      store.dispatch("invoice/fetchMailLists", data).then(() => {
        this.field = this.mail_data;
        this.field.attach = this.$route.query.tns_no;
        this.$set(this.field, "attach", this.$route.query.tns_no);
        this.name = this.mail_data.name;
        var mail =
          this.$route.query.tns_mail && this.$route.query.tns_mail != ""
            ? [
                {
                  text: this.$route.query.tns_mail
                }
              ]
            : [];

        this.$set(this.field, "to_mail", {
          value: "",
          name: mail,
          label: ""
        });
        this.field.from_address =
          this.field.from_address || this.org_details.org_mail;
      });
    },
    // to refresh the fields as empty
    createFreshEventObject() {
      return {
        name: "",
        from_address: "",
        to_mail: {
          value: "",
          name: [],
          label: ""
        },
        cc_me: {
          value: "",
          name: [],
          label: ""
        },
        bcc_me: {
          value: "",
          name: [],
          label: ""
        },
        attach: "",
        body: "",
        subject: ""
      };
    },

    //onSubmit
    onSubmit(scope) {
      var data = {};
      this.$validator.validateAll(scope).then(result => {
        if (result && this.field.to_mail.name.length != 0) {
          this.error_show_mail = false;
          this.error_show=false
          this.submitted = true;
          this.module = this.$route.query.module;
          var id = this.$route.query.id;
          var tns_type = this.$route.query.tns_type;
          var tns_date = this.$route.query.tns_date;
          var tns_currency = this.$route.query.tns_currency;
          var tns_no = this.$route.query.tns_no;
          var cus_id = this.$route.query.cus_id;
          var cus_name = this.$route.query.cus_name;
          var from_date = this.$route.query.from_date;
          var to_date = this.$route.query.to_date;
          var date_format = this.$route.query.date_format;
          var is_export = this.$route.query.is_export;

          if (this.$route.query.tns_type != "Customer Statement"&&this.$route.query.tns_type != "Vendor Statement") {
            data = JSON.stringify({
              id: id,
              from_address: this.field.from_address,
              to_mail: this.field.to_mail.name,
              cc_me: this.field.cc_me.name,
              bcc_me: this.field.bcc_me.name,
              body: this.field.body,
              subject: this.field.subject,
              tns_type: tns_type,
              cus_id: cus_id,
              cus_name: cus_name,
              tns_no: tns_no,
              tns_date: tns_date,
              tns_currency: tns_currency
            });
          } else {
            data = JSON.stringify({
              id: id,
              tns_date: tns_date,
              from_address: this.field.from_address,
              subject: this.field.subject,
              to_mail: this.field.to_mail.name,
              cc_me: this.field.cc_me.name,
              bcc_me: this.field.bcc_me.name,
              body: this.field.body,
              tns_type: tns_type,
              cus_id: cus_id,
              cus_name: cus_name,
              tns_no: tns_no,
              tns_currency: tns_currency,
              from_date: from_date,
              to_date: to_date,
              date_format: date_format,
              is_export: is_export
            });
          }

          this.$store.dispatch("general/receipt", data).then(response => {
            this.$router.push({
              name: this.oldRoute,
              params: {
                id: this.$route.query.id
              },
              query:this.$route.query.tns_type=='Customer Statement'?{tab_index:2}:''
            });
            this.submitted = false;
  if(this.status_code == 200){
            var message_list = [];
            for (var i = 0; i < this.email.Message.length; i++) {
              message_list.push("<li>" + this.email.Message[i] + "</li>");
            }
            var message = "<ul>" + message_list.join("") + "</ul>";
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: message,
              type: this.status_type,
              showCloseButton: true,
            });
        }
     else{
          window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: this.status_message,
              type: this.status_type,
              showCloseButton: true,
            });
          }
          });
        } else {
          // Scroll to error message show
          var content = $(".container-fluid");
          content[0].scrollIntoView(false);
          this.submitted = false;
          this.error_show = true; // validate the form if fail
          if ( this.field.to_mail.name.length == 0) {
            this.mail_error =
              "The to address field is required and must be a valid email";
            this.error_show_mail = true;
            this.error_show = true; 
            this.submitted = false;
          } else {
            this.error_show_mail = false;
          }
        }
      });

      return false;
    }
  },
  //before route enter
  async beforeRouteEnter(routeTo, routeFrom, next) {
    // before this route is loaded
    routeTo.params.routepath = routeFrom.name;

    var data = JSON.stringify({
      tns_type: routeTo.query.tns_type,
      template_id: routeTo.query.template_id ? routeTo.query.template_id : ""
    });
    await store.dispatch("invoice/fetchMailDetails", data);
    await getPageMail(routeTo, next);
  },
  async created() {
    // this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
    this.field = this.mail_data;
    this.show_bcc = this.field.bcc_me.name.length != 0 ? 2 : "";
    this.field.from_address =
      this.org_details.org_mail != "" && this.org_details.org_mail != null
        ? this.org_details.org_mail
        : this.field.from_address;
    var mail =
      this.$route.query.tns_mail && this.$route.query.tns_mail != ""
        ? [
            {
              text: this.$route.query.tns_mail
            }
          ]
        : [];
    this.$set(this.field, "attach", this.$route.query.tns_no);
    this.$set(this.field, "to_mail", {
      value: "",
      name: mail,
      label: ""
    });

    this.name = this.mail_data.name;

    await this.$watch(
      "field",
      function() {
        this.FormUpdate = 1;
      },
      {
        deep: true
      }
    );
  },
  //computed
  computed: {
    ...mapState({
      email: state => state.general.email,
      mail_list: state => state.invoice.mail_list,
      oldRoute: state => state.general.oldRoute,
      mail_data: state => state.invoice.mail_data,
       status_code: (state) => state.general.status_code,
      status_message: (state) => state.general.status_message,
      status_type: (state) => state.general.status_type,
    }),
    ...mapGetters(["org_details"])
  }
};
</script>
<style scoped>
.vue-tags-input {
  max-width: 100% !important;
}
.ti-input {
  border-radius: 3px !important;
}
.attach {
  width: 200px !important;
  border-radius: 0px !important;
  border-top: 1px dashed #dddddd !important;
  border-bottom: 1px dashed #dddddd !important;
  border-right: 1px dashed #dddddd !important;
}
.input-group-text {
  border-right: none !important;
}
</style>